/* ZEB & ZEESHAN - CUSTOM WISHLIST */

(() => {
  const STORAGE_KEY = 'zz_wishlist';

  function getWishlist() {
    try {
      const saved = JSON.parse(
        localStorage.getItem(STORAGE_KEY) || '[]'
      );

      return Array.isArray(saved)
        ? saved.filter(item => typeof item === 'string')
        : [];
    } catch {
      return [];
    }
  }

  function saveWishlist(items) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(items)
      );
      return true;
    } catch {
      return false;
    }
  }

  function updateHearts() {
    const wishlist = getWishlist();

    document.querySelectorAll(
      '.zz-wishlist-btn'
    ).forEach(button => {
      const handle =
        button.dataset.wishlistHandle ||
        button.dataset.productHandle;

      const active = wishlist.includes(handle);

      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute(
        'aria-label',
        active ? 'Remove from wishlist' : 'Add to wishlist'
      );
    });
  }

  async function renderWishlist() {
    const container = document.getElementById(
      'zz-wishlist-page'
    );

    if (!container) return;

    const empty = document.getElementById(
      'zz-wishlist-empty'
    );

    const wishlist = getWishlist();

    container.replaceChildren();

    if (!wishlist.length) {
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;

    const grid = document.createElement('div');
    grid.className = 'zz-wishlist-grid';
    container.appendChild(grid);

    const products = await Promise.all(
      wishlist.map(async handle => {
        try {
          const response = await fetch(
            '/products/' + encodeURIComponent(handle) + '.js'
          );

          if (!response.ok) return null;

          return await response.json();
        } catch {
          return null;
        }
      })
    );

    products.forEach(product => {
      if (!product) return;

      const card = document.createElement('div');
      card.className = 'zz-wishlist-card';

      const link = document.createElement('a');
      link.href = product.url ||
        '/products/' + encodeURIComponent(product.handle);

      const image = document.createElement('img');
      image.src = product.featured_image || '';
      image.alt = product.title;
      image.loading = 'lazy';

      const title = document.createElement('h3');
      title.textContent = product.title;

      const price = document.createElement('p');
      price.textContent = new Intl.NumberFormat('en-PK', {
        style: 'currency',
        currency: 'PKR',
        maximumFractionDigits: 0
      }).format(product.price / 100);

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'zz-wishlist-remove';
      remove.textContent = 'Remove';

      remove.addEventListener('click', () => {
        const updated = getWishlist().filter(
          handle => handle !== product.handle
        );

        if (saveWishlist(updated)) {
          updateHearts();
          renderWishlist();
        }
      });

      link.appendChild(image);
      card.appendChild(link);
      card.appendChild(title);
      card.appendChild(price);
      card.appendChild(remove);
      grid.appendChild(card);
    });

    if (!grid.children.length) {
      grid.remove();
      if (empty) empty.hidden = false;
    }
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('.zz-wishlist-btn');

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const handle =
      button.dataset.wishlistHandle ||
      button.dataset.productHandle;

    if (!handle) return;

    const wishlist = getWishlist();

    const updated = wishlist.includes(handle)
      ? wishlist.filter(item => item !== handle)
      : [...wishlist, handle];

    if (saveWishlist(updated)) {
      updateHearts();
      renderWishlist();
    }
  });

  function initialize() {
    updateHearts();
    renderWishlist();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
  window.addEventListener('pageshow', initialize);

  window.ZZWishlist = {
    getWishlist,
    updateHearts,
    renderWishlist
  };
})();